import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class ProvisioningDataSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.accountId',
      name: 'accountId',
    },
    {
      label: 'label.clientId',
      name: 'clientId',
    },
    {
      label: 'label.organization',
      name: 'organization',
    },
    {
      label: 'label.provisioningId',
      name: 'provisioningId',
    },
    {
      label: 'label.serviceType',
      name: 'serviceType',
      type: 'select',
      tOptions: 'selections:serviceType',
      isClearable: true,
    },
    {
      label: 'label.type',
      name: 'type',
      type: 'select',
      options: [],
      isClearable: true,
    },
    {
      label: 'label.status',
      name: 'status',
      type: 'select',
      tOptions: 'selections:statusProvisioning',
      isClearable: true,
    },
    {
      label: 'label.effectiveStartDate',
      name: 'effectiveStartDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'label.effectiveEndDate',
      name: 'effectiveEndDate',
      type: 'date',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-9';
}

ProvisioningDataSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

ProvisioningDataSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(ProvisioningDataSearchForm);
